/**
 * This utility encapsulate local Storage functionality
 */

/**
 * get Storage Item by Storage Item's key
 * @param {String|string} key
 * @returns {string}
 */
const getLocalStorageItem = key => localStorage.getItem(key);

/**
 * Set Storage Item by Storage Item's key
 * @param {String|string} key
 * @param {String|string} value
 */
const setLocalStorageItem = (key, value) => localStorage.setItem(key, value);

/**
 * Remove Local Storage Item by its key
 * @param {String|string} key
 */
const removeLocalStorageItem = key => localStorage.removeItem(key);

export { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem };
